var map = {
	"./hiddeElement.ts": [
		96442,
		"api-methods-hiddeElement-ts"
	],
	"./panel__remoteApia__onChangeLoginType.ts": [
		22159,
		"api-methods-panel__remoteApia__onChangeLoginType-ts"
	],
	"./panel__remoteApia__onConfigure.ts": [
		38118,
		"api-methods-panel__remoteApia__onConfigure-ts"
	],
	"./panel__remoteQuery__onChangeLoginType.ts": [
		53600,
		"api-methods-panel__remoteQuery__onChangeLoginType-ts"
	],
	"./panel__remoteQuery__onConfigure.ts": [
		34137,
		"api-methods-panel__remoteQuery__onConfigure-ts"
	],
	"./panel__remoteStartProcess__onChangeLoginType.ts": [
		47581,
		"api-methods-panel__remoteStartProcess__onChangeLoginType-ts"
	],
	"./panel__remoteStartProcess__onConfigure.ts": [
		88860,
		"api-methods-panel__remoteStartProcess__onConfigure-ts"
	],
	"./panel__remoteTask__onChangeLoginType.ts": [
		74237,
		"api-methods-panel__remoteTask__onChangeLoginType-ts"
	],
	"./panel__remoteTask__onConfigure.ts": [
		22300,
		"api-methods-panel__remoteTask__onConfigure-ts"
	],
	"./panels/statisticsItems/addEvaluation.ts": [
		95755,
		"api-methods-panels-statisticsItems-addEvaluation-ts"
	],
	"./saveParams.ts": [
		28771,
		"api-methods-saveParams-ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21264;
module.exports = webpackAsyncContext;